import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const e = o((c, l) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: l,
    ...c,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#1D1D40",
              d: "M41.769 26.732c-1.976-2.244-2.964-3.366-2.732-8.44.012-.377.024-.731.012-1.085.854-1.195 1.22-2.646.61-5.06C38.464 7.426 34.013 6 28.5 6c-.378 0-.731.037-1.097.049-14.232.707-13.085 10.914-16.89 15.439-4.732 5.634-4.05 13 .06 15.207 3.061 1.647 6.293 2.549 9.098 3.037-.22 1.183-.402 1.963-.402 1.975l1.183.293s.207-.866.426-2.073c3.83.536 6.61.317 6.61.317s-4.658-6.854-.695-14.134c-1.695-.476-3.72-2.903-2.244-4.488 1.744-1.878 4.037.232 5.012 2.476 3.159-2.927 5.159-2.708 7.135-4.488.402-.354.768-.695 1.122-1.025-.183 5.269 1.036 6.671 3.048 8.952.025.024.049.183-.06.45-.257.586-1.013 1.196-2.135 1.22h-.488l-.097.5c-.951 5-3.012 5.061-5.5 5.061-1.512 0-2.293.44-2.561 1.55-.573 2.401-.537 5.414-.525 5.536l1.22-.025s-.037-2.987.5-5.231c.085-.342.158-.622 1.463-.622 2.39 0 5.317-.074 6.525-5.598 1.475-.195 2.39-1.122 2.731-1.915.293-.67.208-1.305-.17-1.731"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#9DA8F8",
              d: "m8.548 13.975-.939-.78c.159-.183 3.878-4.574 8.927-4.659 1.146 0 2.256.268 3.354.549 2.585.67 5.036 1.305 8.049-1.549l.841.89c-3.5 3.305-6.524 2.525-9.195 1.842-1.061-.268-2.073-.525-3.024-.512-4.488.085-7.988 4.183-8.025 4.22zM10.78 39.842l-.511-1.11c.06-.024 6.621-3.146 7.475-10.061l1.207.146c-.95 7.586-7.878 10.878-8.182 11.012zM12.427 23.67c-3.61 0-6.244-1.182-6.427-1.268l.512-1.11c.073.037 7.695 3.427 14.622-1.768l.732.976c-3.28 2.463-6.646 3.159-9.44 3.159z"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "HairBreakageIcon";
export {
  e as HairBreakageIcon,
  e as default
};
//# sourceMappingURL=index.js.map
